/* eslint-disable no-lonely-if */
/* eslint-disable react/no-unescaped-entities */
/* eslint-disable @typescript-eslint/no-inferrable-types */
/* eslint-disable no-undef */
/* eslint-disable no-unused-vars */
/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable react-hooks/exhaustive-deps */
import {
  Button,
  CircularProgress,
  Drawer,
  IconButton,
  MenuItem,
  OutlinedInput,
  Select,
  TextField,
} from '@material-ui/core';
import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';
import { ContainerJob, InputSearch, MarginContainer, OaPopin } from '@orientaction/commons';
import { JobLayout, TableAnnonce, TableCandidat } from '@orientaction/components';
import { debounce } from 'lodash';
import { useEffect, useState } from 'react';
import { useHistory, useLocation, useParams } from 'react-router-dom';
import { ReactComponent as ArrowLeft } from '../../../Asset/svg/arrow_left_alt.svg';
import { ReactComponent as Search } from '../../../Asset/svg/search.svg';
import { apiServiceNative } from '../../../utils/fetchNative';
import { useStyles } from './style';
import { Close } from '@material-ui/icons';
import { calculateAge, getFromLS } from '@orientaction/utils';
import { useAdminUser, useJobContentAsAdmin } from '@orientaction/hooks';
import { validate } from 'email-validator';

const JobCandidates = (props: any) => {
  const { push } = useHistory();
  const classes = useStyles();

  const [candidats, setCandidats] = useState<Array<CandidatureTableType>>([]);
  const [loading, setLoading] = useState<boolean>(false);
  const [seekValue, setSeekValue] = useState<string>('');
  const [title, setTitle] = useState<string>('');
  const { id }: any = useParams();
  const history = useHistory();
  const parseGender: { [key: string]: string } = {
    '1': 'H',
    '2': 'F',
    homme: 'H',
    femme: 'F',
    'non-binaire': 'NB',
    'Non binaire': 'NB',
  };
  const [dataCanditats, setDataCandidats] = useState<any>([]);
  const [openDrawer, setOpenDrawer] = useState<boolean>(false);
  const [userDataToInvite, setUserDataToInvite] = useState<UserToInviteType>({
    firstname: '',
    lastname: '',
    email: '',
    idJob: '',
  });
  const [jobs, setJobs] = useState<Array<JobType>>([]);
  const [jobToSend, setJobToSend] = useState<string>('');
  const [errorEmail, setErrorEmail] = useState<string>('');
  const userConsultant = JSON.parse(getFromLS('userInfos') || '{}');
  const [openPopin, setOpenPopin] = useState<boolean>(false);
  const [openPopinR, setOpenPopinR] = useState<boolean>(false);
  const [dataAfterChecking, setDataAfterChecking] = useState<any>();
  const { getConsultantId } = useJobContentAsAdmin();
  const { openDrawer: openDraw } = useAdminUser();
  const [firstTime, setFirstTime] = useState<number>(0);

  useEffect(() => {
    fetchJobConsultant(seekValue);
    fetchTitle();
    fetchJobOnly();
  }, []);

  const updateValue = debounce(async event => {
    setLoading(true);
    try {
      const { name, value } = event.target;
      setSeekValue(value);
      await functionToFetching(value);
      setLoading(false);
    } catch (e) {
      setLoading(false);
      console.error(e);
    }
  }, 1000);

  const handleChange = (e: any) => {
    updateValue(e);
  };

  const onKeyDown = (event: any) => {
    updateValue(event);
  };

  const functionToFetching = async (keyword: string) => {
    const response = await apiServiceNative.get(`/api/job/search/${id}?query=${keyword}`);
    if (response) {
      setCandidats(transformNeededData(response));
    }
  };

  const fetchJobConsultant = async (keyword: string) => {
    try {
      setLoading(true);
      await functionToFetching(keyword);
      setLoading(false);
    } catch (e) {
      console.error(e);
      setLoading(false);
    }
  };
  const fetchTitle = async () => {
    try {
      setLoading(true);
      const response = await apiServiceNative.get(`/api/jobs/${id}?fields[0]=title`);
      if (response) {
        setTitle(response.data.attributes.title);
      }
      setLoading(false);
    } catch (e) {
      console.error(e);
      setLoading(false);
    }
  };

  const handleToDelete = async (idC: number) => {
    setLoading(true);
    try {
      const response = await apiServiceNative.delete(`/api/candidatures/${idC}`);
      if (response) {
        await fetchJobConsultant(seekValue);
      }
      setLoading(false);
    } catch (e) {
      setLoading(false);
      console.error(e);
    }
  };

  const checkingMatchingData = (candidature: CandidatureType) => {
    return (
      candidature.sensMatching &&
      candidature.besoinsMatching &&
      candidature.personalityMatching &&
      candidature.equilibreMatching &&
      candidature.talentsMatching
    );
  };

  const transformNeededData = (originalData: Array<CandidatureType>) => {
    return originalData.map((elem: CandidatureType) => {
      return {
        firstname: elem.user.firstname,
        lastname: elem.user.lastname,
        age: elem.user.dayOfBirth ? calculateAge(elem.user.dayOfBirth) : elem.user.age,
        genre: elem.user.gender ? parseGender[elem.user.gender.toLowerCase()] : '',
        ville: elem.user.town,
        diplome: elem.user.diploma,
        phonenumber: elem.user.phone,
        email: elem.user.email,
        avancement: !checkingMatchingData(elem) ? 'en cours' : 'terminé',
        idCandidature: elem.id,
        candidature: elem,
        idUser: elem.user.id,
        idConsultant: elem.user.manager_1,
      } as CandidatureTableType;
    });
  };

  const fetchJobOnly = async () => {
    setLoading(true);
    try {
      const jobData = await apiServiceNative.get(
        `/api/jobs/consultant/${getConsultantId()}?pageSize=100`
      );
      if (jobData && jobData.data) {
        const jobsMapped = jobData.data
          .filter((job: JobType) => job.publishedAt)
          .map((job: JobType) => {
            return {
              title: job.title,
              id: job.id,
            };
          });
        setJobs(jobsMapped);
      }
      setLoading(false);
    } catch (e) {
      console.error(e);
      setLoading(false);
    }
  };

  const handleFieldChange = (field: string, value: any) => {
    setUserDataToInvite({ ...userDataToInvite, [field]: value });
  };
  const sendData = async () => {
    if (!validate(userDataToInvite.email)) {
      setErrorEmail("L'adresse email n'a pas le bon format");
      return;
    }
    setErrorEmail('');
    const checking = await apiServiceNative.post(`/api/job/check-invitation-user`, {
      emailBenef: userDataToInvite.email,
      idJob: userDataToInvite.idJob,
    });
    if (checking.status === 404) {
      const dataNewUser = await apiServiceNative.post(`/api/job/send-invitation/lambda`, {
        firstname: userDataToInvite.firstname,
        lastname: userDataToInvite.lastname,
        email: userDataToInvite.email,
        idJob: userDataToInvite.idJob,
        idUserConsultant: getConsultantId(),
      });
      setOpenDrawer(false);
      await fetchJobConsultant(seekValue);
    } else {
      if (checking.data.rattachement) {
        setDataAfterChecking(checking.data);
        setOpenPopinR(true);
      } else {
        setOpenPopin(true);
        console.log('not rattached');
      }
    }
  };

  const handleConfirmRattachement = async () => {
    try {
      const dataNewUser = await apiServiceNative.post(`/api/job/send-invitation/notrattached`, {
        idUserConsultant: getConsultantId(),
        idJob: userDataToInvite.idJob,
        emailBenef: userDataToInvite.email,
      });
      setOpenDrawer(false);
      setOpenPopin(false);
    } catch (e) {
      console.error(e);
      setOpenPopin(false);
    }
  };

  const handleConfirmCandidat = async () => {
    try {
      const dataNewUser = await apiServiceNative.post(`/api/job/send-invitation/candidat`, {
        idJob: userDataToInvite.idJob,
        idUser: dataAfterChecking.id,
        idUserConsultant: getConsultantId(),
      });
      setOpenDrawer(false);
      setOpenPopinR(false);
    } catch (e) {
      console.error(e);
      setOpenPopinR(false);
    }
  };

  useEffect(() => {
    if (openDraw) {
      setFirstTime(firstTime + 1);
    }
    if (!openDraw && firstTime > 0) {
      fetchJobConsultant(seekValue);
    }
  }, [openDraw]);

  const closeDrawer = () => {
    setOpenDrawer(false);
    setUserDataToInvite({
      firstname: '',
      lastname: '',
      email: '',
      idJob: '',
    });
  };

  return (
    <JobLayout isaddBackground={true} showOverFlow={true}>
      <ContainerJob>
        <MarginContainer big={true}>
          <div className={classes.btn} onClick={() => history.goBack()}>
            <ArrowLeft />
            <div style={{ marginLeft: 15 }}>Revenir aux annonces</div>
          </div>
          <Grid
            container={true}
            spacing={2}
            direction="row"
            justifyContent="space-between"
            alignItems="center"
            style={{ marginBottom: 20, marginTop: 20 }}>
            <Grid item={true} xs={7}>
              <div>
                <Typography variant="h2" className={classes.title}>
                  Offre : <span>{title}</span>
                </Typography>
                <div className={classes.flexNumber}>
                  <div className={classes.number}>
                    <span>{candidats?.length}</span>
                  </div>
                  <Typography className={classes.textNumber}>Candidat(e)s</Typography>
                </div>
              </div>
            </Grid>
            <Grid
              item={true}
              xs={5}
              style={{ display: 'flex' }}
              alignItems="center"
              justifyContent="flex-end">
              <OutlinedInput
                placeholder="Rechercher"
                type="search"
                className={classes.inputSearch}
                onChange={handleChange}
                onKeyDown={onKeyDown}
                id="outlined-adornment-amount"
                startAdornment={<Search style={{ marginRight: 10 }} />}
              />
              <Button variant="contained" color="primary" className={classes.btnPrimarySeek} onClick={() => setOpenDrawer(true)}>
                Inviter un(e) candidat(e)
              </Button>
            </Grid>
          </Grid>
          <span className={classes.separator} />
          <div>
            {loading && <CircularProgress className={classes.loader} />}
            {!loading && candidats && candidats?.length > 0 && (
              <TableCandidat
                candidats={candidats}
                loading={loading}
                idJob={id}
                handleToDelete={handleToDelete}
              />
            )}
            {!loading && candidats?.length === 0 && (
              <Typography className={classes.textNoResult}>Aucun résultat</Typography>
            )}
          </div>
        </MarginContainer>
      </ContainerJob>
      <Drawer
        anchor="bottom"
        open={openDrawer}
        onClose={closeDrawer}
        classes={{ root: classes.rootStyle, paper: classes.drawerContent }}>
        <IconButton
          aria-label="delete"
          className={classes.iconBtnImage}
          style={{ background: 'transparent' }}
          onClick={closeDrawer}>
          <Close style={{ fontSize: 30, color: 'rgb(230, 60, 60)' }} />
        </IconButton>
        <div className={classes.contentDrawer}>
          <Typography variant="h2" color="primary" className={classes.titleTests}>
            Inviter un(e) candidat(e)
          </Typography>
          <div className={classes.separator2} />
          <div style={{ marginTop: 40 }}>
            <div className={classes.containerField}>
              <h3 className={classes.label}>Nom</h3>
              <TextField
                id="create-test-title"
                variant="outlined"
                className={classes.formInput}
                name="test-name"
                value={userDataToInvite.firstname}
                onChange={e => {
                  handleFieldChange('firstname', e.target.value);
                }}
                placeholder="Indiquer le nom"
              />
            </div>
            <div className={classes.containerField}>
              <h3 className={classes.label}>Prénom</h3>
              <TextField
                id="create-test-title"
                variant="outlined"
                className={classes.formInput}
                name="test-name"
                value={userDataToInvite.lastname}
                onChange={e => {
                  handleFieldChange('lastname', e.target.value);
                }}
                placeholder="Indiquer le prénom"
              />
            </div>

            <div className={classes.containerField}>
              <h3 className={classes.label}>Email</h3>
              <TextField
                id="create-test-title"
                variant="outlined"
                className={classes.formInput}
                name="test-name"
                value={userDataToInvite.email}
                onChange={e => {
                  handleFieldChange('email', e.target.value);
                }}
                placeholder="Indiquer l'email"
                type="email"
                helperText={!errorEmail ? '' : 'Entrer un format email correct'}
              />
            </div>
            <div className={classes.containerField}>
              <h3 className={classes.label}>Annonce liée</h3>
              <Select
                variant="outlined"
                value={userDataToInvite.idJob}
                onChange={e => handleFieldChange('idJob', e.target.value)}
                className={classes.select}
                displayEmpty={true}>
                <MenuItem value="" disabled={true}>
                  Sélectionner une annonce
                </MenuItem>
                {jobs &&
                  jobs?.map((job: any, idx: number) => (
                    <MenuItem
                      key={job.id}
                      value={job.id}
                      style={{
                        color: userDataToInvite.idJob === job.id ? '#000A8C' : 'inherit',
                      }}>
                      {job.title}
                    </MenuItem>
                  ))}
              </Select>
            </div>
            <Grid container={true} spacing={2}>
              <Grid item={true} sm={6}>
                <Button
                  variant="outlined"
                  color="secondary"
                  className={classes.btnCancel}
                  style={{ border: '1px solid #E63C3C' }}
                  onClick={closeDrawer}>
                  Annuler
                </Button>
              </Grid>
              <Grid item={true} sm={6}>
                <Button
                  variant="contained"
                  color="primary"
                  className={classes.btnConfirm}
                  disabled={
                    !userDataToInvite.email ||
                    !userDataToInvite.firstname ||
                    !userDataToInvite.lastname ||
                    !userDataToInvite.idJob
                  }
                  onClick={sendData}>
                  Confirmer
                </Button>
              </Grid>
            </Grid>
          </div>
        </div>
      </Drawer>
      <OaPopin
        open={openPopin}
        title="Demande de rattachement d'un bénéficiaire."
        handleConfirm={handleConfirmRattachement}
        handleClose={() => setOpenPopin(false)}>
        <div>
          <Typography variant="h6" className={classes.modalText}>
            L'adresse e-mail que vous avez renseignée appartient à un utilisateur bénéficiaire
            non-rattaché. Souhaitez-vous le rattacher?
          </Typography>
        </div>
      </OaPopin>
      <OaPopin
        open={openPopinR}
        title="Demande d'invitation à l'annonce."
        handleConfirm={handleConfirmCandidat}
        handleClose={() => setOpenPopinR(false)}>
        <div>
          <Typography variant="h6" className={classes.modalText}>
            Ce candidat est déjà en prestation {dataAfterChecking?.service?.name} avec{' '}
            {`${dataAfterChecking?.upper_hierarchy?.lastname} ${dataAfterChecking?.upper_hierarchy?.firstname}`}{' '}
            souhaitez-vous l'ajouter à votre annonce ? Il recevra un email avec les informations de
            celle-ci.
          </Typography>
        </div>
      </OaPopin>
    </JobLayout>
  );
};

export default JobCandidates;
